import React, { Fragment } from 'react'
import Button from '../../../Button'
import { isUndefined } from 'lodash'
import { TABLE_ACTIONS_TYPE } from '../TableActionsCreator/constant'
import ActionDropdown from '../TableActionsCreator/components/ActionDropdown'
import './index.scss'

const TableActions = ({ t, selectedRowsLabel, selectedRowsCount, config }) => {
  const { selectionButtons, defaultButtons } = config

  return (
    <div className='ublique-grid--actions-header'>
      {selectedRowsCount > 0 ? (
        <Fragment>
          <div className='selected-row-count active-selection'>
            <span className='text'>
              {`${
                selectedRowsLabel || 'SELECTED_ROWS_COUNT'
              } : ${selectedRowsCount}`}
            </span>
          </div>
          {selectionButtons.map((selBtn) => createButton({ ...selBtn, t }))}
        </Fragment>
      ) : (
        <Fragment>
          {defaultButtons.map((buttonEl) => {
            if (buttonEl.type === TABLE_ACTIONS_TYPE.DROPDOWN) {
              return <ActionDropdown {...buttonEl} />
            } else if (
              buttonEl.type === TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS
            ) {
              if (buttonEl.componentProps.component) {
                const Component = buttonEl.componentProps.component

                return <Component {...buttonEl?.componentProps} />
              }
            } else if (buttonEl.type === TABLE_ACTIONS_TYPE.CUSTOM) {
              const Component = buttonEl.componentProps.component
              return Component
            } else {
              return createButton({ ...buttonEl, t })
            }
          })}
        </Fragment>
      )}
    </div>
  )
}

const createButton = ({
  id,
  type,
  icon,
  text,
  action,
  disabled = false,
  t
}) => {
  return (
    <Button
      key={id}
      id={id}
      kind={type}
      onClick={action}
      disabled={disabled}
      renderIcon={icon}
    >
      {!isUndefined(text) && t(text)}
    </Button>
  )
}

export default React.memo(TableActions)
